import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_LESSON_ADD, MANAGE_LESSON_DELETE, MANAGE_LESSON_EDIT, MANAGE_LESSON_LIST, MANAGE_LESSON_REMOVE_FILE, MANAGE_LESSON_SHARE, MANAGE_LESSON_SHARED_LIST, MANAGE_LESSON_VIEW } from "config/apiPaths"
import { CHATTER_LESSON_TAGS } from 'config/paths'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const lessonApi = createApi({
    reducerPath: 'lessonApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/lessons",
    }),
    tagTypes: ["LessonList", "LessonDetails"],
    endpoints: (builder) => ({

        // lesson list
        getLessonList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, tag_id, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_LESSON_LIST,
                    data: { search, page, limit, sort, tag_id: tag_id?.length ? tag_id : [], status }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["LessonList"]
        }),

        // delete lesson
        deleteLesson: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_LESSON_DELETE}/${id}`
            }),
            invalidatesTags: ["LessonList", "LessonDetails", "SharedLessonList"]
        }),

        // add lesson
        addLesson: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_LESSON_ADD,
                data
            }),
            invalidatesTags: ["LessonList"]
        }),

        // edit lesson
        editLesson: builder.mutation({
            query: ({ lessonId, data }) => ({
                method: "PUT",
                url: `${MANAGE_LESSON_EDIT}/${lessonId}`,
                data
            }),
            invalidatesTags: ["LessonList", "LessonDetails"]
        }),

        // lesson details
        getLessonDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_LESSON_VIEW}/${id}`,
            }),
            providesTags: ["LessonDetails"],
            transformResponse: (response) => {
                return response.data;
            },
        }),

        // delete lesson
        deleteLessonFile: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_LESSON_REMOVE_FILE}/${id}`
            }),
            invalidatesTags: ["LessonDetails"]
        }),

        // share lesson
        shareLesson: builder.mutation({
            query: ({ lessonId, data }) => ({
                method: "PUT",
                url: `${MANAGE_LESSON_SHARE}/${lessonId}`,
                data
            }),
        }),

        // shared lesson list
        sharedLessonList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: MANAGE_LESSON_SHARED_LIST,
                    data: { search, page, limit, sort, status }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SharedLessonList"]
        }),

        getChatterLessonTags: builder.query({
            query: () => ({
                method: "GET",
                url: CHATTER_LESSON_TAGS,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterLessonTags"]
        }),
    }),
})

export const {
    useGetLessonListQuery,
    useDeleteLessonMutation,
    useAddLessonMutation,
    useEditLessonMutation,
    useGetLessonDetailsQuery,
    useDeleteLessonFileMutation,
    useShareLessonMutation,
    useSharedLessonListQuery,
    useGetChatterLessonTagsQuery
} = lessonApi;